<template>
  <div class="container-fluid">

<router-view>
</router-view>
</div>
</template>

<script>
// import axios from "axios";


export default {
  name: 'App',

  data() {
    return {

  }
},
  methods: {

  }
}

</script>


<style>


</style>



